import React from "react";
import { Link } from "react-router-dom";
import {
  Home, Briefcase, Bus, Store, Construction, ScrollText, Users, Trees, Check, Download, FileText,
} from "lucide-react";
import { program } from "../mock";
import PdfViewer from "./PdfViewer";

const ICONS = { Home, Briefcase, Bus, Store, Construction, ScrollText, Users, Trees, Download };

const Program = () => {
  return (
    <section
      id="program"
      className="bg-campaign-yellow py-16 sm:py-24 px-4 sm:px-6 border-y-4 border-campaign-ink"
    >
      <div className="max-w-7xl mx-auto">
        {/* Veľký nadpis prepájajúci web s letákom */}
        <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl text-campaign-ink leading-[0.95] uppercase max-w-4xl">
          {program.bigHeading}
        </h2>

        <div className="mt-8 mb-12 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="inline-block bg-campaign-blue text-campaign-cream font-display uppercase text-lg sm:text-2xl px-4 py-2 border-2 border-campaign-ink -rotate-1">
              {program.heading}
            </span>
            <p className="mt-4 text-campaign-ink/80 text-base sm:text-lg font-semibold">
              {program.subheading}
            </p>
          </div>
          <a
            href={program.pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            download={program.pdfFileName}
            className="shrink-0 inline-flex items-center gap-2 bg-campaign-blue text-campaign-cream font-display uppercase text-sm sm:text-base px-5 py-4 border-2 border-campaign-ink shadow-brutal hover-lift"
          >
            <Download size={20} /> Stiahnuť program (PDF)
          </a>
        </div>

        <div className="mb-10 flex flex-wrap gap-4">
          <Link
            to="/program"
            className="inline-flex items-center gap-2 bg-campaign-ink text-campaign-cream font-display uppercase text-sm sm:text-base px-5 py-4 border-2 border-campaign-ink shadow-brutal hover-lift"
          >
            <FileText size={20} /> Zobraziť celý program (HTML)
          </Link>
          <PdfViewer url={program.pdfUrl} fileName={program.pdfFileName} label="Prelistovať PDF" />
        </div>

        {/* 4 + 4 na desktope, 2 na tablete, 1 na mobile */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {program.items.map((item) => {
            const Icon = ICONS[item.icon] || Home;
            return (
              <div
                key={item.no}
                className="bg-campaign-cream border-4 border-campaign-ink p-6 shadow-brutal hover-lift flex flex-col"
              >
                <div className="flex items-center justify-between mb-4">
                  <span className="w-12 h-12 bg-campaign-blue border-2 border-campaign-ink flex items-center justify-center">
                    <Icon size={24} className="text-campaign-yellow" />
                  </span>
                  <span className="font-display text-4xl text-campaign-ink/15">{item.no}</span>
                </div>

                <h3 className="font-display text-xl text-campaign-ink mb-1 uppercase leading-tight">
                  {item.title}
                </h3>
                <p className="font-bold text-campaign-coral mb-4">{item.subtitle}</p>

                <ul className="space-y-2 flex-1">
                  {item.bullets.map((b, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="mt-1 shrink-0 w-4 h-4 bg-campaign-coral border-2 border-campaign-ink flex items-center justify-center">
                        <Check size={10} className="text-campaign-cream" strokeWidth={4} />
                      </span>
                      <span className="text-campaign-ink/85 text-sm leading-snug">{b}</span>
                    </li>
                  ))}
                </ul>

                <p className="mt-5 pt-4 border-t-2 border-campaign-ink/15 font-display text-sm text-campaign-ink leading-snug">
                  {item.conclusion}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Program;
